import React, { FC, memo } from 'react'

import { useNavigate } from 'react-router-dom'

import { useAuth } from '@sportworld/js-sdk/src/context/authContext'

import { AccountCardsPanel } from '@/components/AccountCardsPanel'
import { Button } from '@/components/Button/Button'
import { SettingsHeader } from '@/components/SettingsHeader'
import { focusIds, orientation } from '@/constants/focus'
import { icons } from '@/constants/icons'
import { paths } from '@/constants/paths'
import { accountLayoutData } from '@/constants/settings'
import { LogoIcon, LogoPanel } from '@/containers/Auth/styles'
import { SettingsContainer } from '@/containers/styles'
import { useCommonTranslation } from '@/i18n/useCommonTranslation'

import {
  MobileAppImg,
  ContentContainer,
  HeaderElement,
  Title,
  Description,
  Column,
  ColumnFocusNode,
  RegisterWrapper,
  MobileAppImgWrapperAccount,
} from './styles'

const focusId = `${focusIds.SETTINGS_ACCOUNT}${focusIds.CONTAINER_MOD}`

const AccountRaw: FC = () => {
  const navigate = useNavigate()
  const { t } = useCommonTranslation()

  const { isRegisteredUser } = useAuth()

  const goToRegister = () => navigate(paths.REGISTER)
  const goToLogin = () => navigate(paths.LOGIN)

  return (
    <SettingsContainer focusId={focusId} elementType="div">
      <SettingsHeader
        title={t(accountLayoutData.title)}
        description={t(accountLayoutData.description)}
      />
      {isRegisteredUser ? (
        <AccountCardsPanel />
      ) : (
        <ContentContainer>
          <Column>
            <MobileAppImgWrapperAccount>
              <MobileAppImg src={icons.register.mobileAppImage} alt="" />
            </MobileAppImgWrapperAccount>
            <LogoPanel>
              <LogoIcon src={icons.register.favIconWhite} alt="" />
              <LogoIcon src={icons.register.googleIcon} alt="" />
              <LogoIcon src={icons.register.appleIcon} alt="" />
            </LogoPanel>
          </Column>
          <ColumnFocusNode orientation={orientation.VERTICAL}>
            <HeaderElement>
              <Title>{t('pleaseAuthenticate')}</Title>
              <Description>{t('needAccount')}</Description>
            </HeaderElement>
            <Button
              iconSrc={icons.register.loginIcon}
              text={t('login')}
              onClick={goToLogin}
              width={340}
            />
            <RegisterWrapper>
              <Description>{t('dontHaveAccount')}</Description>
              <Button
                iconSrc={icons.navigation.profile}
                text={t('register')}
                onClick={goToRegister}
                width={340}
              />
            </RegisterWrapper>
          </ColumnFocusNode>
        </ContentContainer>
      )}
    </SettingsContainer>
  )
}

export const Account = memo(AccountRaw)
